import { render, staticRenderFns } from "./PerfilV2.vue?vue&type=template&id=bbac9d98"
import script from "./PerfilV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilV2.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports